import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import LoginPage      from './pages/LoginPage';
import OverviewPage   from './pages/OverviewPage';
import OperationsPage from './pages/OperationsPage';
import PerformancePage from './pages/PerformancePage';
import StoragePage    from './pages/StoragePage';
import AnalyticsPage  from './pages/AnalyticsPage';
import RestoreRegisterPage from './pages/RestoreRegisterPage';
import SettingsPage   from './pages/SettingsPage';
import { backupAPI }  from './services/api';

function ProtectedRoutes() {
  const { user, loading } = useAuth();
  const [customer,  setCustomer]  = useState(null);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (user) {
      backupAPI.getCustomers()
        .then(r => setCustomers(r.data || []))
        .catch(console.error);
    }
  }, [user]);

  if (loading) return <div style={{ padding: 60, textAlign: 'center', color: '#64748b' }}>Caricamento...</div>;
  if (!user)   return <Navigate to="/login" replace />;

  return (
    <Layout customer={customer} customers={customers} onCustomerChange={setCustomer}>
      <Routes>
        <Route path="/"            element={<OverviewPage    customer={customer} />} />
        <Route path="/operations"  element={<OperationsPage  customer={customer} />} />
        <Route path="/performance" element={<PerformancePage customer={customer} />} />
        <Route path="/storage"     element={<StoragePage     customer={customer} />} />
        <Route path="/analytics"   element={<AnalyticsPage   customer={customer} />} />
        <Route path="/restore"     element={<RestoreRegisterPage customer={customer} />} />
        <Route path="/settings"    element={<SettingsPage />} />
        <Route path="*"            element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*"     element={<ProtectedRoutes />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
